import React, { useState, useEffect } from 'react';
import '../ImagePrompt.css';
import '../PreviewScreen.css';
import '../Imagenes/ejemplo1.png';
import eyeSVG from '../Iconos/eye.svg';
import arrowSVG from '../Iconos/arrow.svg';

import { useTranslation } from 'react-i18next';

const VALID_MINUTES = 35;

const CarouselPreviewScreen: React.FC = () => {
    const { t } = useTranslation();
    const [selectedImages, setSelectedImages] = useState<string[]>([]);
    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const [isModalOpen, setIsModalOpen] = useState(false);
    let generatedText = '';

    
    // Recuperar el texto generado del localStorage
    const textDataJSON = localStorage.getItem('textData');
    if (textDataJSON) {
        const textData = JSON.parse(textDataJSON);
        generatedText = textData.content;
    }

    useEffect(() => {
        const selectedImagesJSON = localStorage.getItem('selectedImages');
        if (selectedImagesJSON) {
            const imageData = JSON.parse(selectedImagesJSON);
            const timeNow = new Date().getTime();
            const timeElapsed = (timeNow - imageData.timestamp) / 1000 / 60; // Tiempo en minutos

            if (timeElapsed < VALID_MINUTES) {
                setSelectedImages(imageData.images);
            } else {
                localStorage.removeItem('selectedImages'); // Imágenes caducadas
            }
        }
    }, []);



    const handlePreviousImage = () => {
        if (currentImageIndex > 0) {
            setCurrentImageIndex(currentImageIndex - 1);
        }
    };

    const handleNextImage = () => {
        if (currentImageIndex < selectedImages.length - 1) {
            setCurrentImageIndex(currentImageIndex + 1);
        }
    };

    return (
        <div>
            <div className="preview-header">
                <img src={eyeSVG} alt="" /> <h2>{t('Preview')}:</h2>
            </div>
            <div className="preview-container">
                <div className="preview-content">
                    <div className="main-image-container-distribution">
                        {selectedImages.length > 0 && (
                            <div className="preview-image-wrapper" >

                                <img src={selectedImages[currentImageIndex]} alt="Selected" className="preview-image" />
                                <div className="flechas">
                                    <button className="image-nav-left" onClick={handlePreviousImage}>
                                        <img src={arrowSVG} alt="Previous" className='reverse-arrow' />
                                    </button>
                                    <button className="image-nav-right" onClick={handleNextImage}>
                                        <img src={arrowSVG} alt="Next" className='normal-arrow' />
                                    </button>
                                </div>

                            </div>
                        )}
                    </div>
                    {generatedText && (
                        <div className="preview-text">
                            <p>{generatedText}</p>
                        </div>
                    )}
                </div>
            </div>
            {isModalOpen && (
                <div className="modal-backdrop" >
                    <div className="modal-content">
                        <img src={selectedImages[currentImageIndex]} alt="Ampliada" className="modal-image" />
                        <p className="modal-text">{generatedText}</p>
                    </div>
                </div>
            )}
        </div>
    );
};

export default CarouselPreviewScreen;
